<!-- 品牌故事 -->
<template>
    <div class='brandStory'>
        <div class="banner">
            <img src="../../assets/aboutUs/brandStory/品牌故事banner.jpg" alt="">
            <div class="tip">
                <div class="title">探见品牌故事 </div>
                <div class="En">
                    <p>GROUP</p>
                    <p>MEMORABILIA</p>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="red">Red</div>
            <div class="red-con">
                <div class="red-div"></div>
                <div class="red-right-con">
                    <div class="title">赤子之心</div>
                    <div class="line-warp">
                        <div class="yuan"></div>
                        <div class="line"></div>
                    </div>
                    <p class="text">
                        在十四五规划和2035远景目标纲要中，中国的碳中和路线图已经非常明确，构建人类命运共同体和人与自然生命共同体，中国向世界的双碳承诺，需要企业的担当，积极探索改变生产方式，推动智能建造与建筑工业化协同发展，以科技赋能，不断创造绿色奇迹，未来充满未知，我们依然不断向前。
                    </p>
                    <p class="text">
                        大道之行也，天下为公，选贤与能，讲信修睦。窗外雪花飞舞，但触地即化;虽风雪交加，但冻不住苏醒的人心。天不言而四时行，地不语而百物生，与天地和谐共生，是时代命题，更是科技公司的风骨。
                    </p>

                </div>
            </div>
            <div class="blue">Blue</div>
            <div class="blue-con">
                <div class="blue-left-con">
                    <img src="../../assets/aboutUs/brandStory/blue.jpg" alt="">
                    <div class="title">科技重塑</div>
                    <div class="line-warp">
                        <div class="yuan"></div>
                        <div class="line"></div>
                    </div>
                    <p class="text">
                        我们站在产业数字化与工业绿色化交汇的路口，建筑业的双碳，只有数字引擎和产业引警共同驱动，才能兼顾脱碳和经济增长的情况下实现可持续发展。
                    </p>
                    <p class="text">
                        数字化转型的本质在于效率的提升，探见正在通过数字化升级发现能耗关键点和异常点，进而通过智能化系统进行节约和改善，降低生产和流通环节的资源与能源浪费，实现生产资源整合和高效配置，在提升生产力的同时，有效促进节能减排、提质增效。
                    </p>
                    <p class="text">
                        我们希望通过蓝色的进步，带动世界加速变绿，达成零碳目标。
                    </p>
                </div>
                <div class="blue-div"></div>
            </div>
            <div class="green-con">
                <div class="green">Green</div>
                <img src="../../assets/aboutUs/brandStory/green.jpg" alt="">
                <div class="green-div"></div>
                <div class="bottom">
                    <div class="green-k-div"></div>
                    <div class="green-right-con">
                        <div class="title">建筑需要一颗绿色的心</div>
                        <div class="line-warp">
                            <div class="yuan"></div>
                            <div class="line"></div>
                        </div>
                        <p class="text">
                            探见从精工时代而来，向绿色生活而往。
                        </p>
                        <p class="text">
                            探见科技所描摹追寻的“绿色”，是对科技、人文、产业与社会责任饱含赤诚深情的“绿色”，THE PEOPLE, BY THE PEOPLE AND FOR THE PEOPLE。
                        </p>
                        <p class="text">
                            碳中和时代的“绿色建筑”应该是智慧的、智能的、低碳的、节能的、科技的、温情的、艺术的、幸福的，对于孩子的保护、对于长者的照护、对于美好舒适的实现，对于地球环境的捍卫、对于可持续发展的坚守。
                        </p>
                        <p class="text">
                            我们将所有对于建筑的所有美好想象寄予“绿色”二字，从智慧人居到绿色城市，实现低碳生活的全面覆盖，绿色建筑助力碳中和实现。
                        </p>
                    </div>
                </div>
            </div>
            <div class="bottom-title">红色的内核，蓝色的外壳，绿色的征程</div>
            <div class="bottom-title-En">Red core，Blue shell，Green journey</div>
        </div>
    </div>
</template>

<script>

export default {
    name: '',
    components: {},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.brandStory {
    width: 100%;

    .banner {
        width: 100%;
        height: calc(100vh - 48px);
        background-color: #999;
        margin-bottom: 20px;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }

        .tip {
            position: absolute;
            bottom: 86px;
            right: 135px;
            width: 410px;
            height: 188px;
            background-color: rgb(35, 44, 223);
            border-radius: 12px;

            .title {
                text-align: left;
                font-size: 34px;
                color: #fff;
                margin: 50px 0 6px 50px;
            }

            .En {
                margin-left: 50px;

                p {
                    color: #fff;
                }
            }
        }
    }

    .main {
        width: 1000px;
        margin: 0 auto;

        .red {
            font-size: 180px;
            color: rgb(217, 217, 217);
            font-family: 'BlackFont', sans-serif;
        }

        .red-con {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .red-div {
                width: 360px;
                height: 360px;
                border-radius: 12px;
                background-color: rgb(176, 0, 0)
            }

            .red-right-con {
                width: 470px;

                .title {
                    font-size: 36px;
                    font-weight: bolder;
                    margin: 0;
                    text-align: left;
                    font-family: 'BlackFont', sans-serif;
                }

                .line-warp {
                    display: flex;
                    align-items: center;
                    margin: 40px 0;

                    .yuan {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        background-color: rgb(176, 0, 0);
                    }

                    .line {
                        width: calc(100% - 20px);
                        height: 1px;
                        background: rgb(172, 172, 172);
                    }
                }

                .text {
                    font-size: 14px;
                    color: #000;
                    margin-bottom: 20px;
                }
            }
        }

        .blue {
            margin-top: 40px;
            font-size: 180px;
            color: rgb(217, 217, 217);
            text-align: right;
            font-family: 'BlackFont', sans-serif;
        }

        .blue-con {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            img {
                width: 610px;
                height: 320px;
                margin-bottom: 30px;
            }

            .blue-div {
                width: 358px;
                height: 714px;
                border-radius: 12px;
                background-color: rgb(41, 48, 242);
            }


            .blue-left-con {
                width: 470px;

                .title {
                    font-size: 36px;
                    font-weight: bolder;
                    margin: 0;
                    text-align: left;
                    margin-left: 70px;
                    font-family: 'BlackFont', sans-serif;
                }

                .line-warp {
                    display: flex;
                    align-items: center;
                    margin: 40px 0;
                    margin-left: 70px;


                    .yuan {
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        background-color: rgb(41, 48, 242);
                    }

                    .line {
                        width: calc(100% - 20px);
                        height: 1px;
                        background: rgb(172, 172, 172);
                    }
                }

                .text {
                    font-size: 14px;
                    color: #000;
                    margin-bottom: 20px;
                    margin-left: 70px;
                }
            }
        }


        .green-con {
            margin-top: 160px;
            position: relative;

            .green {
                position: absolute;
                top: -130px;
                left: -50px;
                font-size: 180px;
                color: rgb(217, 217, 217);
                text-align: right;
                font-family: 'BlackFont', sans-serif;
            }

            img {
                width: 100%;
                height: 500px;
                object-fit: cover;
                margin-bottom: 30px;
            }

            .green-div {
                position: absolute;
                top: 340px;
                left: -50px;
                width: 370px;
                height: 370px;
                border-radius: 12px;
                background-color: rgb(29, 173, 0);
            }

            .bottom {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;

                .green-k-div {
                    width: 370px;
                    height: 370px;
                    border-radius: 12px;
                    background-color: transparent;
                }

                .green-right-con {
                    width: 50%;

                    .title {
                        font-size: 36px;
                        font-weight: bolder;
                        margin: 0;
                        text-align: left;
                        margin-left: 70px;
                        font-family: 'BlackFont', sans-serif;
                    }

                    .line-warp {
                        display: flex;
                        align-items: center;
                        margin: 40px 0;
                        margin-left: 70px;


                        .yuan {
                            width: 20px;
                            height: 20px;
                            border-radius: 50%;
                            background-color: rgb(29, 173, 0);
                        }

                        .line {
                            width: calc(100% - 20px);
                            height: 1px;
                            background: rgb(172, 172, 172);
                        }
                    }

                    .text {
                        font-size: 14px;
                        color: #000;
                        margin-bottom: 20px;
                        margin-left: 70px;
                    }
                }
            }
        }

        .bottom-title {
            text-align: center;
            font-size: 36px;
            font-weight: bolder;
            margin-top: 110px;
        }

        .bottom-title-En {
            text-align: center;
            font-size: 32px;
            font-weight: bolder;
            margin-top: 10px;
            color: rgb(228, 228, 228);
            margin-bottom: 100px;
        }
    }
}
</style>